import { useEffect } from 'react';
import AccordionMenu from './AccordionMenu';
import UserInfo from './UserInfo';

interface MobileMenuProps {
  isOpen: boolean;
  onClose: () => void;
}

const MobileMenu = ({ isOpen, onClose }: MobileMenuProps) => {
  // Close menu on escape key
  useEffect(() => {
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener('keydown', handleEscape);
      document.body.style.overflow = 'hidden';
    }

    return () => {
      document.removeEventListener('keydown', handleEscape);
      document.body.style.overflow = 'unset';
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <>
      {/* Overlay */}
      <div
        className="fixed inset-0 bg-black bg-opacity-50 z-40 desktop:hidden"
        onClick={onClose}
      />

      {/* Slide-in Menu */}
      <div className="fixed inset-y-0 left-0 w-64 bg-admin-sidebar text-white z-50 desktop:hidden transform transition-transform duration-300 ease-in-out flex flex-col">
        {/* Header */}
        <div className="p-6 border-b border-admin-sidebarHover flex items-center justify-between">
          <div>
            <h1 className="text-xl font-bold">管理コンソール</h1>
            <p className="text-sm text-gray-400 mt-1">Hakusensha Enet</p>
          </div>
          <button
            onClick={onClose}
            className="text-white hover:text-gray-300"
            aria-label="メニューを閉じる"
          >
            <svg
              className="w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>

        {/* Navigation Menu */}
        <div className="flex-1 overflow-y-auto py-4">
          <AccordionMenu />
        </div>

        {/* User Info */}
        <div className="border-t border-admin-sidebarHover">
          <UserInfo />
        </div>
      </div>
    </>
  );
};

export default MobileMenu;
